export const menuItemPhotoHandler = {
    pathPattern: '/brands/:brandId/menu/item/:itemId',
    toWeb: ({ brandId, itemId }) => ({
        path: `/brands/${brandId}/menu/item/${itemId}`,
    }),
    toNative: ({ brandId, itemId }, locationId) => `/${brandId}/${locationId}/menu/item/${itemId}/camera`,
    meta: {
        title: 'Menu item photo',
        description: 'Prompts the operator to add a photo for a menu item.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'itemId', in: 'path', required: true },
            {
                name: 'fromPhotoRecommendationNotification',
                in: 'query',
                required: false,
                surface: 'app',
            },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', itemId: 'exampleItemId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=menu-item-photo.js.map